import * as React from "react";
import {
    Button, Divider, Grid2 as Grid, Dialog, DialogTitle, DialogActions, DialogContent, Box
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CopyrightBlock from './CopyrightBlock';
import PrivacyPolicyHtml from './PrivacyPolicy';

const CenterLinks: React.FC = () => {
    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const [showPrivacyPolicyDialog, setShowPrivacyPolicyDialog] = React.useState(false);

    const centerLinksStyle = {
        color: 'white',
        fontSize: '16px',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        fontWeight: 'normal',
        margin: theme.spacing(0, 1),
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'steelblue',
            color: 'white'
        }
    };

    const dividerStyle = {
        backgroundColor: 'white',
        opacity: 0.3,
        margin: theme.spacing(1, 1, 0, 1)
    };

    const rootStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        paddingTop: '20px',
        marginLeft: theme.spacing(10)
    };

    const linksContainerStyle = {
        paddingRight: theme.spacing(6)
    };

    const renderPrivacyPolicyDialog = (breakpoint: string) => (
        <Dialog open={showPrivacyPolicyDialog} maxWidth={breakpoint as any}>
            <DialogTitle id="max-width-dialog-title">
                Privacy Policy
            </DialogTitle>
            <DialogContent>
                {PrivacyPolicyHtml}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowPrivacyPolicyDialog(false)}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderButtons = () => (
        <>
            <Button href={process.env.REACT_APP_MEDIA_NCQA_MAINPAGE} target='_blank' sx={centerLinksStyle}>
                NCQA Homepage
            </Button>
            <Button href={process.env.REACT_APP_MEDIA_NCQA_ABOUT} target='_blank' sx={centerLinksStyle}>
                About Us
            </Button>
            <Button href={process.env.REACT_APP_MEDIA_NCQA_CONTACT} target='_blank' sx={centerLinksStyle}>
                Contact Us
            </Button>
            <Button sx={centerLinksStyle} onClick={() => setShowPrivacyPolicyDialog(true)}>
                Privacy Policy
            </Button>
            <Button href={process.env.REACT_APP_MEDIA_NCQA_MY} target='_blank' sx={centerLinksStyle}>
                My NCQA
            </Button>
        </>
    );

    if (isLgUp) {
        return (
            <Box sx={rootStyle}>
                <Grid container direction='row' justifyContent='flex-start' alignContent='flex-start' sx={linksContainerStyle}>
                    {renderButtons()}
                    {renderPrivacyPolicyDialog('lg')}
                </Grid>
                <Divider sx={dividerStyle} />
                <CopyrightBlock />
            </Box>
        );
    } else if (isMdUp) {
        return (
            <Box sx={rootStyle}>
                <Grid container direction='row' justifyContent='flex-start' alignContent='flex-start' sx={linksContainerStyle}>
                    {renderButtons()}
                    {renderPrivacyPolicyDialog('md')}
                </Grid>
                <Divider sx={dividerStyle} />
                <Grid container direction='row' justifyContent='flex-start' alignContent='flex-start' sx={linksContainerStyle}>
                    <Button href={process.env.REACT_APP_MEDIA_NCQA_MY} target='_blank' sx={centerLinksStyle}>
                        My NCQA
                    </Button>
                </Grid>
                <Divider sx={dividerStyle} />
                <CopyrightBlock />
            </Box>
        );
    } else {
        return (
            <Box sx={rootStyle}>
                <Grid container direction='row' justifyContent='flex-start' alignContent='flex-start' sx={linksContainerStyle}>
                    {renderButtons()}
                    {renderPrivacyPolicyDialog('sm')}
                </Grid>
                <Divider sx={dividerStyle} />
                <CopyrightBlock />
            </Box>
        );
    }
};

export default CenterLinks;
